<div class="container" *ngIf="showFooter">
    <div #stepFooter id="steps-container" [ngClass]="isMobile ? 'step-mobile' : 'step-desk'">
        <ng-container *ngIf="isMobile; else desktopSection">
            <div class="action-panel">
                <section *ngIf="!isNonZeroPaymentMethod && !isAdyenMethod && !isPaybyrdMethod && !isZeroPaymentMethod  && !INDRA_isSelectingRoundtripDeparture()">
                    <button class="button button-accent" aria-label="this.btnText" [disabled]="isDisabled || disabledContinue" (click)="INDRA_handleAction()">{{this.btnText}}</button>
                </section>
                
                <!-- for Non-Zero Payment -->
                <section *ngIf="isNonZeroPaymentMethod">
                    <button *ngIf="!isPaypalPaymentMethod" class="button button-accent" (click)="INDRA_handleAction()" [attr.aria-label]="'bookingPayment.aria.confirmBooking' | ibeadmin | async">
                        <span skeletonLoader [translationKey]="'footer.text.confirmBooking'">
                            {{'footer.text.confirmBooking' | ibeadmin | async}}
                        </span>
                    </button>
    
                    <ng-container *ngIf="isPaypalPaymentMethod">
                        <app-paypal-payment [promoCodesAndVoucher]="promoCodesAndVoucher" (emitLoader)="overlayLoaderEvent($event)" (emitVoucherError)="INDRA_errorRedeemVoucherPaypal($event)"></app-paypal-payment>
                    </ng-container>
    
                    <div class="card-secure-logos__wrapper" *ngIf="(selectedPaymentMethod === 'credit_card' || selectedPaymentMethod === 'debit_card')">
                        <app-svg class="card-secure-logo" svg="sprite.svg#logo--visa_secure" [alt]="'Visa Secure logo'"></app-svg>
                        <app-svg class="card-secure-logo not-first" svg="sprite.svg#logo--mastercard_id_check" [alt]="'Visa Secure logo'"></app-svg>
                        <app-svg *ngIf="market === 'FR'" class="card-secure-logo not-first" svg="sprite.svg#credit_card--carte_bleue" [alt]="'Cartes Bancaries logo'"></app-svg>
                    </div>
                </section>
    
                <!-- for adyen Payment -->
                <section *ngIf="isAdyenMethod">
                    <button class="button button-accent" (click)="INDRA_handleAction()" [attr.aria-label]="'bookingPayment.aria.confirmBooking' | ibeadmin | async" [disabled]="!isButtonPaymentDisableOverride">
                        <span skeletonLoader [translationKey]="'footer.text.confirmBooking'">
                            {{'footer.text.confirmBooking' | ibeadmin | async}}
                        </span>
                    </button>
                </section>
    
                <!-- for paybyrd Payment -->
                <section *ngIf="isPaybyrdMethod">
                        <button class="button button-accent" (click)="INDRA_handleAction()" [attr.aria-label]="'bookingPayment.aria.confirmBooking' | ibeadmin | async">
                            <span skeletonLoader [translationKey]="'footer.text.confirmBooking'">
                                {{'footer.text.confirmBooking' | ibeadmin | async}}
                            </span>
                        </button>
                </section>
    
                <!-- for Zero Payment -->
                <section *ngIf="isZeroPaymentMethod">
                    <button [disabled]="isButtonPaymentDisableOverride" class="button button-accent" (click)="INDRA_handleAction()" [attr.aria-label]="'bookingPayment.aria.confirmBooking' | ibeadmin | async">
                        <span skeletonLoader [translationKey]="'footer.text.confirmBooking'">
                            {{'footer.text.confirmBooking' | ibeadmin | async}}
                        </span>
                    </button>
                </section>
            </div>
            <div class="toggle-container">
                <div class="price-container">
                    <div>
                        <ng-container *ngIf="current_page != 'dates'; else dateContent">
                            <a class="text-link" (click)="INDRA_handlePriceBreakDown()" aria-label="Open a new window to show price breakdown" href="javascript:;" role="button">
                                <span skeletonLoader [translationKey]="'footer.text.priceBreakdown'">
                                    {{ 'footer.text.priceBreakdown' | ibeadmin | async }}
                                </span>
                            </a>
                        </ng-container>
                        <ng-template #dateContent>
                            <ng-container *ngIf="!showDeparture; else clearLink">
                                <span class="no-date-title">{{ 'footer.text.selectDates' | ibeadmin | async }}</span>
                            </ng-container>
                            <ng-template #clearLink>
                                <a class="text-link" href="javascript:;" role="button" (click)="INDRA_clearDates()"
                                    aria-label="Clear dates to select new ones">
                                    <span skeletonLoader [translationKey]="'footer.text.selectNewDates'">
                                        {{ 'footer.text.selectNewDates' | ibeadmin | async }}
                                    </span>
                                </a>
                            </ng-template>
                        </ng-template>
                    </div>
                    <div (click)="INDRA_handleToggle()" id="price-box" [ngClass]="current_page != 'dates' ? 'visible' : 'invisible'">
						<div class="prices">
							<span class="price">{{ INDRA_getTotalPrice() | indracurrency }}
							</span>
						</div>                       
						<app-svg class="expand-icon" [ngClass]="['toggle-expand', this.state]"
							svg="icons.svg#general--arrow--bottom" [attr.aria-label]="'Expand and collapse action'"
							[alt]="'Arrow icon'"></app-svg>
                    </div>
                </div>
            </div>
            <app-expand-collapse [state]="state">
                <div class="passenger-edit-container">
                    <div class="separador"></div>
                    <div class='type-container'>
                        <div class="booktype">
                            <span class="step-title">{{this.INDRA_getBookType()}}</span>
                            <span class="step-info-bound">{{this.passengers_label}}</span>
                        </div>
                        <div class="edit-box" [ngClass]="current_page != 'dates' ? 'visible' : 'invisible'">
                            <a class="text-link" (click)="INDRA_editSearch()" aria-label="Edit book selection" href="javascript:;"
                                role="button">
                                <span skeletonLoader [translationKey]="'footer.text.edit'">
                                    {{ 'footer.text.edit' | ibeadmin | async }}
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="departure-container"
                    [ngClass]="current_page != 'dates' && showDeparture ? 'visible' : 'hidden'">
                    <div class="separador"></div>
                    <div class='type-container'>
                        <div class="departure">
                            <span class="step-title">
                                {{this.INDRA_getDepartureTitle()}}
                            </span>
                            <span
                                class="step-info-bound"
                                [ngClass]="this.showDepartureDetails ? 'visible' : 'invisible'"
                            >
                                {{this.depDetails.bound}}
                            </span>
						    <span
                                *ngIf="this.is_stopover && this.stopover.when == 'outbound'"
                                skeletonLoader [translationKey]="'footer.text.stopover'"
							    class="stopover-info"
                            >
                                {{ 'footer.text.stopover' | ibeadmin | async }}
                                {{this.stopover.days}}
                                {{ 'footer.text.days' | ibeadmin | async }}
                            </span>
                        </div>
                        <ng-container *ngFor='let flights of multi_flights; let i = index; let even = even'>
                            <div *ngIf='even' class="multi-legs-container">
                                <span>{{multi_flights[i].label}}</span>
                                <span>{{multi_flights[i+1].label}}</span>
                            </div>
                        </ng-container>
                    </div>
                </div>
                <div class="return-container" [ngClass]="showReturn ? 'visible' : 'hidden'">
                    <div class="separador"></div>
                    <div class='type-container'>
                        <div class="return">
                            <span class="step-title">{{INDRA_getReturnTitle()}}</span>
                            <span
                                class="step-info-bound"
							    *ngIf="this.showReturnDetails"
                            >
                                {{this.retDetails.bound}}
                            </span>
						    <span
                                *ngIf="this.is_stopover && this.stopover.when == 'inbound'"
                                skeletonLoader [translationKey]="'footer.text.stopover'"
							    class="stopover-info"
                            >
                                {{ 'footer.text.stopover' | ibeadmin | async }}
                                {{this.stopover.days}}
                                {{ 'footer.text.days' | ibeadmin | async }}
                            </span>
                        </div>
                    </div>
                </div>
            </app-expand-collapse>
            <div class="footer-fallback__overlay" 
                (click)="INDRA_handleToggle()">
            </div>
        </ng-container>
        <ng-template #desktopSection>
            <div id="book-type-box">
                <div class="booktype">
                    <span class="step-title">{{this.INDRA_getBookType()}}</span>
                    <span class="booktype-passenger step-info">{{this.passengers_label}}</span>
                </div>
                <div class="step-divisor"></div>
            </div>
            <div id="departure-box" [ngClass]="INDRA_getDepBoxClasses()">
                <div class="departure"> 
                    <span class="step-title" *ngIf="current_page != 'dates'; else dateLink">{{this.INDRA_getDepartureTitle()}}
                    </span>
                    <ng-template #dateLink>
                        <a class="text-link" href="javascript:;" role="button" (click)="INDRA_clearDates()"
                            aria-label="Clear dates to select new ones">
                            <span skeletonLoader [translationKey]="'footer.text.selectNewDates'">
                                {{ 'footer.text.selectNewDates' | ibeadmin | async }}
                            </span>
                        </a>
                    </ng-template>

                    <ng-container *ngIf="booking_type !== 'M'; else multi">
                        <div
                            class="departure-flights step-info"
                            *ngIf="this.showDepartureDetails"
                        >
                            <span *ngIf="this.showDeparture" class="step-info-bound">{{this.depDetails.bound}}</span>
                            <span class="step-info-date">{{this.depDetails.date}}</span>
                            <span
                                *ngIf="this.is_stopover && this.stopover.when == 'outbound'"
                                skeletonLoader [translationKey]="'footer.text.stopover'"
                                class="stopover-info"
                            >
                                {{ 'footer.text.stopover' | ibeadmin | async }}
                                {{this.stopover.days}}
                                {{ 'footer.text.days' | ibeadmin | async }}
                            </span>
                        </div>
                    </ng-container>

                    <ng-template #multi>
                        <div class="multi-flights-container" [ngClass]="multi_flights.length > 0 ? 'visible' : 'invisible'">
                            <ng-container *ngFor='let flights of multi_flights; let i = index; let even = even'>
                                <div *ngIf='even'>
                                    <div class="multi-legs-container" *ngIf="multi_flights[i]">
                                        <span class="step-info">
                                            {{multi_flights[i].label}}
                                            <span class="stop-label"></span>
                                        </span>
                                        <span
                                            *ngIf="multi_flights[i].stopover"
                                            class="stopover-info"
                                            skeletonLoader [translationKey]="'footer.text.stopover'"
                                        >
                                            {{ 'footer.text.stopover' | ibeadmin | async }}
                                        </span>
                                    </div>
                                    <div class="multi-legs-container" *ngIf="multi_flights[i+1]">
                                        <span class="step-info">
                                            {{multi_flights[i+1].label}}
                                            <span class="stop-label"></span>
                                        </span>
                                        <span *ngIf="multi_flights[i+1].stopover" class="stopover-info" skeletonLoader [translationKey]="'footer.text.stopover'">
                                            {{ 'footer.text.stopover' | ibeadmin | async }}
                                        </span>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </ng-template>
                </div>
                <div class="step-divisor" *ngIf="current_page != 'dates'"></div>
            </div>
            <div id="return-box" [ngClass]="showReturn ? 'visible' : 'hidden'">
                <div class="return">
                    <span class="step-title">{{INDRA_getReturnTitle()}}</span>
                    <div 
                        class="return-flights step-info"
                        *ngIf="this.showReturnDetails"
                    >
                        <span class="step-info-bound">{{this.retDetails.bound}}</span>
                        <span class="step-info-date">{{this.retDetails.date}}</span>
                        <span
                            *ngIf="this.is_stopover && this.stopover.when == 'inbound'"
                            skeletonLoader [translationKey]="'footer.text.stopover'"
                            class="stopover-info"
                        >
                            {{ 'footer.text.stopover' | ibeadmin | async }}
                            {{this.stopover.days}}
                            {{ 'footer.text.days' | ibeadmin | async }}
                        </span>
                    </div>
                </div>
                <div class="step-divisor"></div>
            </div>
            <div class="action-box" [ngClass]="INDRA_getActionBoxClasses()">
                <div class="edit-box" [ngClass]="current_page != 'dates' ? 'visible' : 'invisible'">
                    <a class="text-link" (click)="INDRA_editSearch()" aria-label="Edit book selection" href="javascript:;"
                        role="button">
                        <span skeletonLoader [translationKey]="'footer.text.edit'">
                            {{ 'footer.text.edit' | ibeadmin | async }}
                        </span>
                    </a>
                </div>
                <div class="action-panel">
                    <div class="price-breakdown" [ngClass]="current_page != 'dates' ? 'visible' : 'invisible'">
                        <div class="prices">
                            <span class="price">{{ INDRA_getTotalPrice() | indracurrency }}</span>
                        </div>
                        <a class="text-link" (click)="INDRA_handlePriceBreakDown()" aria-label="Open a new window to show price breakdown" href="javascript:;" role="button">
                            <span skeletonLoader [translationKey]="'footer.text.priceBreakdown'">
                                {{ 'footer.text.priceBreakdown' | ibeadmin | async }}
                            </span>
                        </a>
                    </div>
                    <div>
                        <ng-container *ngIf="!isNonZeroPaymentMethod && !isAdyenMethod && !isPaybyrdMethod && !isZeroPaymentMethod && !INDRA_isSelectingRoundtripDeparture()">
                            <button class="button button-accent" aria-label="this.btnText" [disabled]="isDisabled || disabledContinue" (click)="INDRA_handleAction()">{{this.btnText}}</button>
                        </ng-container>
                        
                        <!-- for Non-Zero Payment -->
                        <ng-container *ngIf="isNonZeroPaymentMethod">
                            <div class="container">
                                <div class="grid no-padding">
                                    <div class="col-12 col-tp-12 col-p-12 payment-bottom-confirmation__wrapper top-gap">
                                        <button *ngIf="!isPaypalPaymentMethod" class="button button-accent" (click)="INDRA_handleAction()" [attr.aria-label]="'bookingPayment.aria.confirmBooking' | ibeadmin | async">
                                            <span skeletonLoader [translationKey]="'footer.text.confirmBooking'">
                                                {{'footer.text.confirmBooking' | ibeadmin | async}}
                                            </span>
                                        </button>
    
                                        <ng-container *ngIf="isPaypalPaymentMethod">
                                            <app-paypal-payment [promoCodesAndVoucher]="promoCodesAndVoucher" (emitLoader)="overlayLoaderEvent($event)" (emitVoucherError)="INDRA_errorRedeemVoucherPaypal($event)"></app-paypal-payment>
                                        </ng-container>
    
                                        <div class="card-secure-logos__wrapper" *ngIf="(selectedPaymentMethod === 'credit_card' || selectedPaymentMethod === 'debit_card')">
                                            <app-svg class="card-secure-logo" svg="sprite.svg#logo--visa_secure" [alt]="'Visa Secure logo'"></app-svg>
                                            <app-svg class="card-secure-logo not-first" svg="sprite.svg#logo--mastercard_id_check" [alt]="'Visa Secure logo'"></app-svg>
                                            <app-svg *ngIf="market === 'FR'" class="card-secure-logo not-first" svg="sprite.svg#credit_card--carte_bleue" [alt]="'Cartes Bancaries logo'"></app-svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
    
                        <!-- for adyen Payment -->
                        <ng-container *ngIf="isAdyenMethod">
                            <button class="button button-accent" (click)="INDRA_handleAction()" [attr.aria-label]="'bookingPayment.aria.confirmBooking' | ibeadmin | async" [disabled]="!isButtonPaymentDisableOverride">
                                <span skeletonLoader [translationKey]="'footer.text.confirmBooking'">
                                    {{'footer.text.confirmBooking' | ibeadmin | async}}
                                </span>
                            </button>
                        </ng-container>
    
                        <!-- for paybyrd Payment -->
                        <ng-container *ngIf="isPaybyrdMethod">
                                <button class="button button-accent" (click)="INDRA_handleAction()" [attr.aria-label]="'bookingPayment.aria.confirmBooking' | ibeadmin | async">
                                    <span skeletonLoader [translationKey]="'footer.text.confirmBooking'">
                                        {{'footer.text.confirmBooking' | ibeadmin | async}}
                                    </span>
                                </button>
                        </ng-container>
    
                        <!-- for Zero Payment -->
                        <ng-container *ngIf="isZeroPaymentMethod">
                            <div class="container">
                                <div class="grid no-padding">
                                    <div class="col-12 col-tp-12 col-p-12 payment-bottom-confirmation__wrapper">
                                        <button [disabled]="isButtonPaymentDisableOverride" class="button button-accent" (click)="INDRA_handleAction()" [attr.aria-label]="'bookingPayment.aria.confirmBooking' | ibeadmin | async">\
                                            <span skeletonLoader [translationKey]="'footer.text.confirmBooking'">
                                                {{'footer.text.confirmBooking' | ibeadmin | async}}
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                    
                </div>
            </div>
        </ng-template>
    </div>
</div>
